// extracted by mini-css-extract-plugin
module.exports = {"content":"TravelPage_content__v6wP4"};